import NotificationService from 'App/babel/NotificationService';

// `errorTranslated` is appended verbatim to the translated body by
// SystemNotificationReducer — it doesn't run through $translate, so we use it
// to surface raw server error messages safely.
type NotificationConfig = {
	icon: string;
	style: string;
	title: string;
	body: string;
	errorTranslated?: string;
};

type NotifyOptions = {
	/**
	 * Set false when the surface that made the call is already showing the
	 * server's own explanation inline. A refusal the user can act on ("run this
	 * routine once first") is not "Something went wrong — please try again", and
	 * saying both at once contradicts the advice. The console log still happens.
	 */
	toast?: boolean;
};

// Toasts a failed AI workspace API request and logs the raw error for devs.
export const notifyAIWorkspaceError = (err: unknown, context?: string, opts?: NotifyOptions): void => {
	console.error(`[AIWorkspace${context ? `:${context}` : ''}]`, err);
	if (opts?.toast === false) {
		return;
	}
	// A 401 means the session is gone and Resource._handleError is already redirecting to /login,
	// so a toast would only land on the login screen. Logged above either way. Nothing else is
	// suppressed: this is also the catch for mutations (saving a routine, BYOK keys), where
	// swallowing would make a blocked save look like a silent no-op.
	if ((err as { response?: { status?: number } })?.response?.status === 401) {
		return;
	}
	const message = err instanceof Error ? err.message : err == null ? '' : String(err);
	const config: NotificationConfig = {
		icon: 'times',
		style: NotificationService.style.ERROR,
		title: 'assistant.apiErrorTitle',
		body: 'assistant.apiErrorBody',
		errorTranslated: message
	};
	NotificationService.add(config);
};
